import { BaseContainer, Header } from "./components/base";
import link_expired from "../../assets/images/link_expired.svg";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { Stack } from "@altimateai/lego";

interface ExpiredLocationState {
  inviteDate?: number;
}

const Expired = () => {
  const { state } = useLocation() as { state: ExpiredLocationState };
  const inviteDate = state?.inviteDate
    ? dayjs.unix(state.inviteDate).utc().format("DD-MMM-YY")
    : ""; // in case the invite timestamp is not passed.
  return (
    <BaseContainer
      footer={
        <Stack direction="row" className="al-items-center al-gap-1">
          <span className="al-text-muted-foreground">Learn more about </span>
          <a
            className="al-text-primary hover:al-underline"
            href="https://www.altimate.ai/"
            target="_blank"
            rel="noreferrer"
          >
            Altimate AI
          </a>
        </Stack>
      }
    >
      <img src={link_expired} alt="Link Expired" className="al-mb-6" />
      <Header>Your Invitation Link Expired</Header>
      <p className="al-text-muted-foreground al-mb-4">
        The {inviteDate && `invitation email was sent on ${inviteDate}, the`}{" "}
        invitation link has expired{inviteDate && " after 30 days"}.
      </p>
      <p className="al-text-muted-foreground">
        Reach out to the sender and ask for a fresh invitation link. Don&apos;t be
        shy, they clearly want you there!
      </p>
    </BaseContainer>
  );
};

export { Expired };

